function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.106,0H3C1.344,0,0,1.343,0,3v94c0,1.657,1.344,3,3,3h75.106c1.657,0,3-1.343,3-3V3 C81.106,1.343,79.763,0,78.106,0 M75.106,94H6.001V6h69.105V94z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.084,33.969h13.414c1.656,0,3-1.343,3-3V17.556c0-1.657-1.344-3-3-3H19.084c-1.657,0-3,1.343-3,3v13.413 C16.084,32.626,17.427,33.969,19.084,33.969 M22.084,20.556h7.414v7.413h-7.414V20.556z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.084,59.707h13.414c1.656,0,3-1.343,3-3V43.293c0-1.657-1.344-3-3-3H19.084c-1.657,0-3,1.343-3,3v13.414 C16.084,58.364,17.427,59.707,19.084,59.707 M22.084,46.293h7.414v7.414h-7.414V46.293z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.084,85.444h13.414c1.656,0,3-1.343,3-3V69.031c0-1.657-1.344-3-3-3H19.084c-1.657,0-3,1.343-3,3v13.413 C16.084,84.102,17.427,85.444,19.084,85.444 M22.084,72.031h7.414v7.413h-7.414V72.031z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.642,32.825c0.543,0.689,1.361,1.106,2.238,1.142c0.04,0.002,0.079,0.002,0.118,0.002 c0.835,0,1.635-0.349,2.204-0.965l11.992-12.992c1.125-1.219,1.049-3.117-0.17-4.24c-1.217-1.125-3.114-1.049-4.238,0.169 L50.179,26.35l-1.535-1.948c-1.024-1.3-2.912-1.525-4.213-0.5c-1.302,1.026-1.525,2.911-0.5,4.213L47.642,32.825z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.787,41.469l-9.607,10.409l-1.535-1.948c-1.025-1.303-2.912-1.526-4.213-0.5 c-1.301,1.025-1.525,2.911-0.5,4.213l3.71,4.71c0.544,0.689,1.362,1.107,2.239,1.142c0.039,0.001,0.078,0.002,0.117,0.002 c0.836,0,1.637-0.349,2.205-0.965l11.992-12.992c1.124-1.217,1.049-3.116-0.169-4.239C62.808,40.175,60.912,40.251,59.787,41.469"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.642,84.258c0.543,0.689,1.361,1.106,2.238,1.142c0.04,0.001,0.079,0.002,0.118,0.002 c0.835,0,1.635-0.349,2.204-0.965l11.992-12.993c1.125-1.218,1.049-3.116-0.17-4.239c-1.217-1.126-3.114-1.05-4.238,0.169 l-9.607,10.409l-1.535-1.948c-1.024-1.301-2.912-1.526-4.213-0.5c-1.302,1.025-1.525,2.911-0.5,4.213L47.642,84.258z"
});

var SvgAttivita = function SvgAttivita(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 101,
    viewBox: "-0.514 -0.835 82 101",
    enableBackground: "new -0.514 -0.835 82 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttivita, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attivita.2cfce8ef.svg";
export { ForwardRef as ReactComponent };